export const SANTA_PRESETS_PANEL_NAME =
  'compPanels.panels.Widget.widgetPresetsPanel';
